module.exports = __webpack_public_path__ + "static/img/fullscreen-image_consulting-services_768.7ba6ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_consulting-services_768.png
// module id = aMuW
// module chunks = 0